const config = {
  PORT : 7770,
  WEBSITE_URL : "https://awb-website.airwaybill.com/",
  baseUrl : "https://awb-website-backend.airwaybill.com"
}

module.exports = config;




// WEBPACK FOOTER //
// ./config/config.js